function change_contact_form(value) {

    $('[data-show-for-reason]').hide();
    $('[data-show-for-reason=' + value + ']').show();

    if (value == 'contact_request') {
        $('.product_request').hide();
        $('[name=product_sku]').attr('disabled', 'disabled');
        $('[name=product_name]').attr('disabled', 'disabled');
    } else {
        $('.product_request').show();
        $('[name=product_sku]').removeAttr('disabled');
        $('[name=product_name]').removeAttr('disabled');
    }
}

$(document).ready(function () {
    if ($('#contact_request_form').length > 0) {
        $('select[name=reason]').change(function () {
            change_contact_form($(this).val());
        });

        change_contact_form($('select[name=reason]').val());
    }
});
